module.exports = __webpack_public_path__ + "static/media/detailedSubtractCricket.9056040b.svg";